/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".persona_1d363f74{fontSize:'14px';verticalAlign:'-webkit-baseline-middle'}\n"}]);
export const persona = "persona_1d363f74";